module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6afd82e5e0300c16d5937fc2df7a1e5a.png";